import { Outlet, Link, useParams, useLocation } from 'react-router-dom';
import { useCompany } from './CompanyLayout';
import { 
  Package, 
  Settings2, 
  ClipboardList, 
  TrendingUp 
} from 'lucide-react';

export default function CompanyERP() {
  const { companyId } = useParams();
  const { company } = useCompany();
  const location = useLocation();

  const erpNavItems = [
    {
      path: `/company/${companyId}/erp/machines`,
      label: 'Machines',
      icon: Settings2,
    },
    {
      path: `/company/${companyId}/erp/parts`,
      label: 'Parts',
      icon: Package,
    },
    {
      path: `/company/${companyId}/erp/work-orders`,
      label: 'Work Orders',
      icon: ClipboardList,
    },
    {
      path: `/company/${companyId}/erp/demand`,
      label: 'Demand',
      icon: TrendingUp,
    },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="flex flex-col h-full">
      {/* ERP Sub-navigation */}
      <div className="border-b border-border bg-card px-6 py-3">
        <div className="flex items-center gap-1">
          {erpNavItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                isActive(item.path)
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:text-foreground hover:bg-muted'
              }`}
            >
              <item.icon className="w-4 h-4" />
              {item.label}
            </Link>
          ))}
        </div>
      </div>

      {/* ERP Content */}
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
